import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../../data/store'
import { combineFirstAndLastName, getNetworkResponseError, isStatusOK } from '../../../util/utill'
import { APIEndPoints } from '../../APIEndPoints'
import { sitConfig } from '../../config'
import { sendEventApi } from '../../sendEvent'
const responseParser = (data: any) => {
  if (isStatusOK(data)) {
    if (data?.data) {
      console.log(
        data?.data,
        'response parser fetchUser API try block check what data we are sending to respponse parser dada? data',
      )
      return data?.data || data;
    }
    console.log('response parser fetchUser API try block', data)
    return data
  } else {
    throw getNetworkResponseError(data)
  }
}
export const fetchUserBC = (tokens: any, body: { mobileNumber: string }) => {
  console.log('DEBUG: Tokens being sent', {
    accessToken: RootStore?.bcAppInfo?.userAccessToken,
    identifier: RootStore?.bcAppInfo?.userIdentifier,
  })

  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier

  const requestBody = {
    user: {
      mobile: {
        countryCode: '+91',
        mobileNumber: body?.mobileNumber,
      },
    },
  }
  // console.log('Avinash API Body:', JSON.stringify(requestBody, null, 2))
  // console.log('Avinash x-user-access-token:', config.headers['x-user-access-token'])
  // console.log('Avinash x-userid-token:', config.headers['x-userid-token'])
  const request: Request<{}> = {
    apiPath: APIEndPoints.fetchUser,
    method: 'POST',
    config: config,
    body: requestBody,
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      console.log('check what data we are passing to executeRequest response parser fetchUser API try block')
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      const networkError = {
        message: err?.message || err?.data?.error?.message || 'Network Error',
        code: err?.errorCode || err?.data?.error?.code || '500',
        original: err, // Keep for debugging if needed
      }

      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: networkError.message,
      })

      throw networkError // Throw a consistent object
    })
}
